import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { DefaultImageBaseurl, endPoints } from "../../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";

import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import DeleteModel from "../../../components/DeleteModel";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const Promo = () => {
  const [editData, setEditData] = useState({});
  const [createData, setCreateData] = useState(false);
  const [rowDataToDelete, setRowDataToDelete] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [promoName, setPromoName] = useState("");
  const [creative, setCreative] = useState("");
  const [thumbimg, setThumbImg] = useState("");
  const [showthumbimg, setShowThumbImg] = useState("");
  const [showcreative, setShowCreative] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [promoCopy, setPromoCopy] = useState(null);
  const [termConditions, setTermConditions] = useState(null);
  const [menuSort, setMenuSort] = useState(null);
  const [checkboxes, setCheckboxes] = useState({
    isCheckedActive: false,
    isCheckedFeatured: false,
  });
  const [promoSite, setPromoSite] = useState("");
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [name]: checked,
    }));
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setCreative(file);
      setShowCreative(imageUrl);
      UploadImage(file);
    }
  };
  const UploadImage = (files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    setIsLoading(true);
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setCreative(result.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error", error));
  };

  const handleFileChangeThumb = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setThumbImg(file);
      setShowThumbImg(imageUrl);
      UploadImageThumb(file);
    }
  };
  const UploadImageThumb = (files) => {
    var formdata = new FormData();
    formdata.append("file", files);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    setIsLoading(true);
    let imgUrl = `${endPoints.apiBaseUrl}${endPoints.api.UPLOAD_BANNER}`;
    fetch(imgUrl, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setThumbImg(result.data);
        setIsLoading(false);
      })
      .catch((error) => console.log("error", error));
  };

  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    // api call
    // fetchUserData(filteredItems);
  }, []);
  useEffect(() => {
    // api call
    promoList();
  }, []);

  const promoList = async () => {
    let url = `${endPoints.api.GET_PROMO}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success" &&  response?.data.length > 0 ) {

          const filteredData = response?.data.filter(item => item.promoSite === "Casino");
          console.log('filteredData',filteredData)
          setRows(filteredData);

          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handleOk = () => {
    if (
      promoName &&
      creative &&
      thumbimg &&
      startDate &&
      startTime &&
      endDate &&
      endTime &&
      promoCopy &&
      termConditions &&
      menuSort &&
      promoSite
    ) {
      let url = editData?.id
        ? `${endPoints.api.UPDATE_PROMO}`
        : `${endPoints.api.ADD_PROMO}`;

      const newStartDate = new Date(`${startDate}T${startTime}Z`).toISOString();
      const newEndDate = new Date(`${endDate}T${endTime}Z`).toISOString();

      let payload = {
        promo_name: promoName,
        creative: creative,
        thumb_url: thumbimg,
        startdate: newStartDate,
        starttime: startDate,
        enddate: newEndDate,
        endtime: startDate,
        promo_copy: promoCopy,
        terms_condition: termConditions,
        menu_sort_order: menuSort,
        isactive: checkboxes.isCheckedActive ? 1 : 0,
        isfeatured: checkboxes.isCheckedFeatured ? 1 : 0,
        promoSite:  "Casino"     //  promoSite || "",
      };
      if (editData?.id) {
        payload.id = editData.id;
      }
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message);
            promoList();
            console.log(response);
            handleClose();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    } else {
      ErrorToast("all fields are required");
    }
  };
  useEffect(() => {
    if (editData) {
      setPromoName(editData.promo_name || "");
      let imageFullPath =
        editData.creative !== undefined
          ? `${endPoints.apiBaseUrl}${editData.creative}`
          : "";
      setShowCreative(imageFullPath || "");
      setCreative(editData.creative || "");
      let imageFullPathFormob =
        editData.thumb_url !== undefined
          ? `${endPoints.apiBaseUrl}${editData.thumb_url}`
          : "";
      setShowThumbImg(imageFullPathFormob || "");
      setThumbImg(editData.thumb_url || "");
      setStartDate(
        editData.startdate
          ? moment(editData.startdate).format("YYYY-MM-DD")
          : ""
      );
      setStartTime(
        editData.startdate ? moment.utc(editData.startdate).format("HH:mm") : ""
      );
      setEndDate(
        editData.enddate ? moment(editData.enddate).format("YYYY-MM-DD") : ""
      );
      setEndTime(
        editData.enddate ? moment.utc(editData.enddate).format("HH:mm") : ""
      );
      setPromoCopy(editData.promo_copy || "");
      setTermConditions(editData.terms_condition || "");
      setMenuSort(editData.menu_sort_order || "");
      setCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        isCheckedFeatured: editData.isfeatured || false,
        isCheckedActive: editData.isactive || false,
      }));
      setPromoSite(editData?.promoSite || "");
    }
  }, [editData]);

  const handleDelete = (row) => {
    setRowDataToDelete(row);
    setShowDeleteModal(true);
  };

  const deletePromo = (row) => {
    const id = rowDataToDelete.id;

    let url = `${endPoints.api.DELETE_PROMO}${id}`;
    setIsLoading(false);
    deleteData(url)
      .then((response) => {
        console.log("update_Res", response);
        setIsLoading(false);
        if (response.status == 200) {
          setShowDeleteModal(false);
          promoList();
          SuccesToast("Deleted Successfully");
        } else {
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const handleSwitchChange = (row, param, value) => {
    const updatedRow = { ...row, [param]: value === 0 ? 1 : 0 };
    updatePromo(updatedRow);
  };

  const updatePromo = (payload) => {
    const id = payload.id;
    let url = `${endPoints.api.UPDATE_PROMO}`;
    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          promoList();
          console.log(response);
          handleClose();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  //  Promo Filter
  const [filteredRows, setFilteredRows] = useState(rows);
  const [filterValue, setFilterValue] = useState("");

  const handleFilterChange = (event) => {
    const newFilterValue = event.target.value.toLowerCase();
    setFilterValue(newFilterValue);

    if (newFilterValue === "") {
      setFilteredRows(rows);
    } else {
      const filteredData = rows.filter((item) =>
        item.promo_name.toLowerCase().includes(newFilterValue)
      );
      setFilteredRows(filteredData);
    }
  };

  const rowsToDisplay = filterValue.length > 0 ? filteredRows : rows;

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        <DeleteModel
          showModal={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onDelete={deletePromo}
        />
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2 heading-table"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    Promos
                  </h3>
                </div>
              </div>

              <div style={{ marginTop: "10px" }}>
                <div className="table_search">
                  <TextField
                    style={{ marginBottom: "10px" }}
                    placeholder="Enter promo name..."
                    type="text"
                    onChange={handleFilterChange}
                    value={filterValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        aria-label="a dense table"
                        stickyHeader
                        aria-label="sticky table"
                        sx={{ minWidth: 500 }}
                        aria-label="custom pagination table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Promo ID</TableCell>
                            <TableCell align="center">Promo Name</TableCell>
                            <TableCell align="center">Start Date </TableCell>
                            <TableCell align="center">End Date</TableCell>
                            <TableCell align="center">Creative</TableCell>
                            <TableCell align="center">Thumb Img</TableCell>
                            <TableCell align="center">Sort Order</TableCell>
                            <TableCell align="center">Featured</TableCell>
                            <TableCell align="center">Active</TableCell>
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay
                            .slice(
                              page * rowsPerPage,
                              rowsPerPage === -1
                                ? rowsToDisplay.length
                                : page * rowsPerPage + rowsPerPage
                            )
                            .map((row) => (
                              <TableRow
                                key={row.id}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                              >
                                <TableCell align="center">{row.id}</TableCell>
                                <TableCell align="center">
                                  {row.promo_name}
                                </TableCell>
                                <TableCell align="center">
                                  {moment
                                    .utc(row.startdate)
                                    .format("YYYY-MM-DD HH:mm")}
                                </TableCell>
                                <TableCell align="center">
                                  {moment
                                    .utc(row.enddate)
                                    .format("YYYY-MM-DD HH:mm")}
                                </TableCell>

                                <TableCell align="center">
                                  <img
                                    src={`${DefaultImageBaseurl}${row.creative}`}
                                    style={{ height: "50px" }}
                                  />
                                </TableCell>

                                <TableCell align="center">
                                  <img
                                    src={`${DefaultImageBaseurl}${row.thumb_url}`}
                                    style={{ height: "50px" }}
                                  />
                                </TableCell>

                                <TableCell
                                  align="center"
                                  style={{ width: "20%" }}
                                >
                                  <Form.Control
                                    value={row.menu_sort_order}
                                    // onChange={(e) => setLimit(e.target.value)}
                                  />
                                </TableCell>

                                <TableCell align="center">
                                  <Switch
                                    checked={row.isfeatured !== 0}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "isfeatured",
                                        row.isfeatured
                                      )
                                    }
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <Switch
                                    checked={row.isactive !== 0}
                                    onChange={() =>
                                      handleSwitchChange(
                                        row,
                                        "isactive",
                                        row.isactive
                                      )
                                    }
                                  />
                                </TableCell>

                                <TableCell align="center">
                                  <EditIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setShow(true);
                                      setCreateData(true);
                                      setEditData(row);
                                    }}
                                  />
                                  <DeleteIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDelete(row)}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={6} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[
                                5,
                                10,
                                25,
                                { label: "All", value: -1 },
                              ]}
                              colSpan={12}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{
                                inputProps: {
                                  "aria-label": "rows per page",
                                },
                                native: true,
                              }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>
                  <>
                    <Modal
                      show={show}
                      onHide={handleClose}
                      // style={{ marginTop: "10%" }}
                      size="lg"
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Manage Promos:</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row">
                          <div className="col-md-8">
                            <Form.Group
                              className="mb-3"
                              controlId="providerName"
                            >
                              <Form.Label>Promo Name </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Promo Name"
                                value={promoName}
                                onChange={(event) => {
                                  setPromoName(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Upload Creative </Form.Label>
                              <Form.Label
                                className="text-danger"
                                style={{ fontSize: "12px", fontWeight: "800" }}
                              >
                                Normal image should be (350*350) <br />
                                For Featured Image (1100*350)
                              </Form.Label>
                              <Form.Control
                                type="file"
                                placeholder="Upload Creative"
                                onChange={handleFileChange}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="startDate">
                              <Form.Label>Start Date</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Start Date"
                                value={startDate}
                                onChange={(event) => {
                                  setStartDate(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="startTime">
                              <Form.Label>Start Time</Form.Label>
                              <Form.Control
                                type="time"
                                placeholder="Start Time"
                                value={startTime}
                                onChange={(event) => {
                                  setStartTime(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            {showcreative && (
                              <div>
                                <img
                                  src={showcreative}
                                  alt="Selected"
                                  style={{ maxWidth: "100px" }}
                                />
                              </div>
                            )}
                          </div>

                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="endDate">
                              <Form.Label>End Date</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="End Date"
                                value={endDate}
                                onChange={(event) => {
                                  setEndDate(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="endTime">
                              <Form.Label>End Time</Form.Label>
                              <Form.Control
                                type="time"
                                placeholder="End Time"
                                value={endTime}
                                onChange={(event) => {
                                  setEndTime(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="game">
                              <Form.Label>Upload Thumb Image </Form.Label>
                              {/* <Form.Label
                                className="text-danger"
                                style={{ fontSize: "12px", fontWeight: "800" }}
                              >
                                Normal image should be (350*350) <br />
                                For Featured Image (1100*350)
                              </Form.Label> */}
                              <Form.Control
                                type="file"
                                placeholder="Upload Creative"
                                onChange={handleFileChangeThumb}
                              />
                            </Form.Group>
                          </div>

                          {/* <div className="col-md-4"></div> */}
                          <div className="col-md-8">
                            <Form.Group className="mb-3" controlId="promoCopy">
                              <Form.Label>Promo Copy :</Form.Label>
                              <Form.Control
                                as="textarea"
                                value={promoCopy}
                                onChange={(event) => {
                                  setPromoCopy(event.target.value);
                                }}
                                // value={
                                //   `get 10% Cahback on all your play this week paid back to tour saga coins account on Tuesday.You can play knowing
                                //   that even if you lose there is still some cash heading yor way.`
                                // }
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-4">
                            {showthumbimg && (
                              <div>
                                <img
                                  src={showthumbimg}
                                  alt="Selected"
                                  style={{ maxWidth: "100px" }}
                                />
                              </div>
                            )}
                          </div>

                          {/* <div className="col-md-4"></div> */}

                          <div className="col-md-8">
                            <Form.Group
                              className="mb-3"
                              controlId="termConditions"
                            >
                              <Form.Label>Terms and Conditions :</Form.Label>
                              <Form.Control
                                as="textarea"
                                value={termConditions}
                                onChange={(event) => {
                                  setTermConditions(event.target.value);
                                }}
                                // disabled={true}
                                //    value={
                                //   `1. You must be a member and playing with saga coins to qualify.
                                //    2. Spin Saga Casino will pay you 10% on all cumulative losses over the promotional period....`
                                // }
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4"></div>

                          <div className="col-md-4">
                            <Form.Group className="mb-3" controlId="menuSort">
                              <Form.Label>Menu Sort order</Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="100"
                                value={menuSort}
                                onChange={(event) => {
                                  setMenuSort(event.target.value);
                                }}
                              />
                            </Form.Group>
                          </div>
                          <div className="col-md-4" style={{ marginTop: "5%" }}>
                            <Form.Check
                              inline
                              label="Active"
                              name="isCheckedActive"
                              type={"checkbox"}
                              id={`inline-${"checkbox"}-1`}
                              onChange={handleCheckboxChange}
                              checked={checkboxes.isCheckedActive}
                            />
                            <Form.Check
                              inline
                              label="Featured"
                              name="isCheckedFeatured"
                              type={"checkbox"}
                              id={`inline-${"checkbox"}-2`}
                              onChange={handleCheckboxChange}
                              checked={checkboxes.isCheckedFeatured}
                            />
                          </div>
                          {/* <div className="col-md-4">
                            <FormControl>
                              <FormLabel id="demo-radio-buttons-group-label">
                                Promotion Site
                              </FormLabel>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                defaultValue="female"
                                name="radio-buttons-group"
                                style={{ display: "flex" }}
                              >
                                <FormControlLabel
                                  value="DFS"
                                  control={<Radio />}
                                  label="DFS"
                                  checked={promoSite == "DFS" ? true : false}
                                  onChange={() => {
                                    setPromoSite("DFS");
                                  }}
                                />
                                <FormControlLabel
                                  value="Casino"
                                  control={<Radio />}
                                  label="Casino"
                                  checked={promoSite == "Casino" ? true : false}
                                  onChange={() => {
                                    setPromoSite("Casino");
                                  }}
                                />
                              </RadioGroup>
                            </FormControl>
                          </div> */}
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={handleOk}
                          style={{
                            background: "#04631e",
                            borderColor: "#04631e",
                          }}
                        >
                          Apply
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginTop: "20px",
                }}
              >
                <Button
                  variant="primary"
                  style={{ background: "#04631e", borderColor: "#04631e" }}
                  onClick={() => {
                    setShow(true);
                    setEditData({});
                    setCreateData(true);
                    setShowCreative("");
                  }}
                >
                  Add New Promo
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Promo;
